import { useParams, Navigate } from "react-router-dom";
import RestaurantDemo from "./RestaurantDemo";
import ClinicDemo from "./ClinicDemo";
import CafeDemo from "./CafeDemo";
import PaloCafeDemo from "./PaloCafeDemo";

export default function DemoRouter() {
  const { slug } = useParams();

  if (!slug) return <Navigate to="/demos" replace />;

  const key = slug.toLowerCase();

  if (key.includes("restaur") || key === "restaurant") return <RestaurantDemo />;
  if (key.includes("clinic") || key === "clinic") return <ClinicDemo />;
  if (key === "palo") return <PaloCafeDemo />;
  if (key === "cafe" || key.includes("cafe")) return <CafeDemo />;

  // Unknown demo -> redirect to demos listing
  return <Navigate to="/demos" replace />;
}
